export default __webpack_public_path__ + "static/1-6-2-0-d4af255bc5334a617d8c3c1dcd2e08bd.jpg";